import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import Select from 'react-select';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName} from '../Univ.js'

function Ticketing(){
  const [eqpitems, setEqpItems] = useState([]);
  const [Tickview, setTickView] = useState([]);
  const [user, setUser] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [TickData,setTickData]=useState({
        "ticket":'',
        "equipment":'',
        "subject":'',
        "reason":'',
        "priority":'',
        "attachment":'',
        "open_status":'',
        "status":'',
        "addedby":'',
        "ip_add":'',
        "f_files": null, // Add the f_files property with an initial value of null
    });

  useEffect(() => {
    fetchPharmData();
    fetchData();
  }, []);

  function fetchPharmData() {
    axios.get(`${baseUrl}eqp-search/?totqty=gt0`)
      .then((pharmResponse) => {
        setEqpItems(pharmResponse.data);
      })
      .catch(error => {
        console.log(error);
      });
  }
  function fetchData() {
    axios.get(baseUrl + "user-search/")
      .then(response => {
        setUser(response.data);
      })
      .catch(error => {
        console.log(error);
      });
  }
  useEffect(() => {
    fetchTickData();
  }, []);

  function fetchTickData() {
    axios.get(`${baseUrl}view-ticket/${userName}/`)

      .then(response => {
        setTickView(response.data);
      })
      .catch(error => {
        console.log(error);
      });
  }

  const columns = [
    { field: 'ticket', headerName: 'Ticket ID', width: 120 },
    { field: 'add_date', headerName: 'Raised On', width: 120 },
    { field: 'addedby', headerName: 'Raised By', width: 120},
    { field: 'subject', headerName: 'Subject', width: 100},
    { field: 'reason', headerName: 'Reason', width: 170 },
    { field: 'priority', headerName: 'Priority', width: 90,
    renderCell: (params) => {
      const priority = params.value;
      return (
        <>
          {priority === 'Low' && (
            <span className="badge bg-info">{priority}</span>
          )}
          {priority === 'Normal' && (
            <span className="badge bg-primary">{priority}</span>
          )}
          {priority === 'High' && (
            <span className="badge bg-danger">{priority}</span>
          )}
        </>
      );
    },
    },
    { field: 'open_status', headerName: 'Status', width: 90,
    renderCell: (params) => {
      const open_status = params.value;
      return (
        <>
          {open_status === 0 && (
            <span className="badge bg-info">Raised</span>
          )}
          {open_status === 1 && (
            <span className="badge bg-primary">Open</span>
          )}
          {open_status === 2 && (
            <span className="badge bg-warning">InProgress</span>
          )}
          {open_status === 3 && (
            <span className="badge bg-success">Answered</span>
          )}
          {open_status === 4 && (
            <span className="badge bg-danger">Reopened</span>
          )}
          {open_status === 5 && (
            <span className="badge bg-dark">Closed</span>
          )}
        </>
      );
    },
    },
  ];

  const handleTickChange = (event) => {
        setTickData({
            ...TickData,
            [event.target.name]:event.target.value
        });
    }
  const handleFileChange = (event) => {
        setTickData({
            ...TickData,
            f_files: event.target.files[0], // Update the f_files property with the selected file
        });
    };
    const formSubmitmed = (e) => {
      e.preventDefault();
      axios.post(`${baseUrl}get_ticket_id/`)
        .then(response => {
          const ticket_id = response.data.value;
          const _formData = new FormData();
          const priority = document.getElementById("ftype").value;
          _formData.append('priority', priority);
          if(TickData.f_files){
            _formData.append('attachment', TickData.f_files, TickData.f_files.name);
          }
          _formData.append('ticket', ticket_id);
          _formData.append('equipment', selectedOption.value);
          _formData.append('subject', TickData.subject);
          _formData.append('reason', TickData.reason);
          _formData.append('open_status', '0');
          _formData.append('status', '1');
              _formData.append('addedby', userName);
          _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);

          axios.post(`${baseUrl}ticket-create/`, _formData)
            .then(response => {
              if(response.status==200 || response.status==201){
                Swal.fire({
                  title: 'Tick Sent.',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setTimeout(() => {
                  window.location.href = '/ticketing/';
                }, 3000);
              }
            })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed to Send Tick. Please try again later.',
                'error'
              );
            });
       })
        .catch(error => {
          console.log(error);
          Swal.fire(
            'Error!',
            'Failed to generate unique value. Please try again later.',
            'error'
          );
        });
  };

   const handleDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result)=>{
            if(result.isConfirmed){
               try{
                   axios.delete(baseUrl+'delete-Tick/'+id)
                   .then(function (response) {
                      Swal.fire('success', 'Data has been Deleted');
                      window.location.reload();
                    });
               }catch(error){
                    Swal.fire('error', 'Data has not been deleted');
               }
            }else{
                  Swal.fire('error', 'Data has not been deleted');
            }

        })
    }
  const handleSelectChange = selectedOption => {
        setSelectedOption(selectedOption);
    };

    const options = eqpitems.map(equipment => ({
        value: equipment.id,
        label: equipment.product
    }));
  return (
    <section className="container mt-4">
    <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-ticket"
        aria-hidden="true" style={{color: 'red'}}></i> Raise Ticket</h3>
    <div className="row mt-4">
    <form>
    <div className="table-responsive">
       <table className="erp-table-modern">
        <tbody>

          <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
            <td>Asset Name: </td>
            <td>
             <Select
                value={selectedOption}
                onChange={handleSelectChange}
                options={options}
                isSearchable
                placeholder="Select Asset"
            />
            </td>
          </tr>
          <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
            <td>Subject : </td>
            <td>
             <input type="text" className="no-comma" name="subject" id="subject"
                value={TickData.subject}
                onChange={handleTickChange} />
            </td>
          </tr>
          <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
            <td>Tick : </td>
            <td>
             <textarea className="no-comma" tabIndex="0" name="reason" id="reason"
                value={TickData.reason}
                onChange={handleTickChange} >
             </textarea>
            </td>
          </tr>
          <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
            <td>Priority : </td>
            <td>
            <select name="ftype" id="ftype" value={TickData.ftype} onChange={handleTickChange}>
            <option value="Low">Low</option>
            <option value="Normal">Normal</option>
            <option value="High">High</option>
            </select>
            </td>
          </tr>
          <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
            <td>File Upload :</td>
            <td>
          <input type="file" className="form-control" name="f_files"
            onChange={handleFileChange} id="f_files" />
          </td>
          </tr>
      </tbody>
    </table>
    </div>
    <button type="button" onClick={formSubmitmed} className="btn btn-primary mt-4">Submit</button>
    </form>
    </div>
      <div className="row mt-4">
       <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
        <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
        View Tickets
       </h3>
           {!isLoading && Tickview.length > 0 ? (
            <div style={{ height: "100%", width: "100%" }}>
              <DataGrid className="mt-4"
                sx={{
                  boxShadow: 4,
                  border: 4,
                  borderColor: 'primary.light',
                  '& .MuiDataGrid-cell:hover': {
                    color: 'primary.main',
                  },
                }}
                rows={Tickview}
                columns={columns}
                pageSize={10}
                slots={{
                  toolbar: GridToolbar,
                }}
                autoHeight
              />
            </div>
          ) : (
            <></>
          )}

    </div>
    </section>
  )
}
export default Ticketing;
